import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { API_BASE_URL } from '../../application/ports/api-base-url.token';
import { TimeseriesRepositoryPort } from '../../application/ports/timeseries-repository.port';
import {
  TimeseriesQueryParams,
  TimeseriesResult,
} from '../../domain/models/timeseries.model';

@Injectable()
export class TimeseriesApiAdapter implements TimeseriesRepositoryPort {
  private readonly http = inject(HttpClient);
  private readonly baseUrl = inject(API_BASE_URL);

  async query(params: TimeseriesQueryParams): Promise<TimeseriesResult> {
    const url = `${this.baseUrl}/api/asset-instances/${params.obid}/timeseries/${params.propertyName}`;
    const httpParams: Record<string, string> = {
      assetType: params.assetType,
      startTime: params.startTime,
      endTime: params.endTime,
    };

    if (params.interpolationFrequency) {
      httpParams['interpolationFrequency'] = params.interpolationFrequency;
    }
    if (params.interpolationStrategy) {
      httpParams['interpolationStrategy'] = params.interpolationStrategy;
    }

    return firstValueFrom(
      this.http.get<TimeseriesResult>(url, { params: httpParams }),
    );
  }
}
